import styles from '../ChallengeDetail.module.scss';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import image11 from './images/1-1.jpg';
import image31 from './images/3-1.jpg';
import image41 from './images/4-1.jpg';

export const EnterTheEpicDrawDescription = () => {
    return (
        <div className={styles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Подарки»</b>
                </div>
                <ChallengeDetailHelpImage image={image11} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Откройте вкладку <b>«Авто»</b>
                </div>
                <ChallengeDetailHelpImage image={image31} helpText='Это картинка. Ищите вкладку в разделе «Подарки».' />
            </p>

            <p>
                <div>
                    Найдите ближайший розыгрыш сертификата на <b>2000 руб.</b> и с помощью ползунка используйте для участия 3 фиолетовых билета
                </div>
                <ChallengeDetailHelpImage image={image41} helpText='Это картинка. Ищите ползунок и кнопку на вкладке «Подарки».' />
            </p>
        </div>
    );
}